import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ExtentSnapshot = {
  xmin: number;
  ymin: number;
  xmax: number;
  ymax: number;
  wkid?: number;
};

export type Bookmark = {
  id: string;
  name: string;
  extent: ExtentSnapshot;
  visible_layer_ids: string[];
  basemap_id: string;
  created_at: number;
};

type State = {
  bookmarks: Bookmark[];
  add: (b: Bookmark) => void;
  remove: (id: string) => void;
  get: (id: string) => Bookmark | undefined;
  rename: (id: string, name: string) => void;
};

let counter = 0;
export function nextBookmarkId(): string {
  counter += 1;
  return `bm_${Date.now().toString(36)}_${counter.toString(36)}`;
}

export const useBookmarkStore = create<State>()(
  persist(
    (set, getState) => ({
      bookmarks: [],
      add: (b) => set((s) => ({ bookmarks: [...s.bookmarks, b] })),
      remove: (id) => set((s) => ({ bookmarks: s.bookmarks.filter((b) => b.id !== id) })),
      get: (id) => getState().bookmarks.find((b) => b.id === id),
      rename: (id, name) =>
        set((s) => ({
          bookmarks: s.bookmarks.map((b) => (b.id === id ? { ...b, name } : b)),
        })),
    }),
    { name: 'rcmc-bookmarks' },
  ),
);
